import React, { useRef, useState } from "react";
import { AiOutlineShoppingCart } from "react-icons/ai";
import DrawerCartSummary from "./DrawerCartSummary/DrawerCartSummary";
import { styled } from "@mui/material";
import { useLocation } from "react-router-dom";

function CardButton({ countActualTrue }) {
  const [openDrawer, setOpenDrawer] = useState(false);
  const location = useLocation();
  const isCheckout = location.pathname === "/checkout";
  const classCheckout = isCheckout ? "checkout" : "btn-click";
  const backdropRef = useRef(null);

  const showDrawer = () => {
    // en checkout no se debe mostrar drawer
    if (isCheckout) {
      setOpenDrawer(false);
    } else {
      setOpenDrawer(true);
    }
  };

  const onCloseDrawer = () => {
    setOpenDrawer(false);
  };
  const hideDrawer = () => {
    if (backdropRef.current) {
      backdropRef.current.focus();
      backdropRef.current.click();
    }
  };

  const Button = styled("button")(() => ({
    "&.btn-click": {
      "&:hover": {
        background: "#2287B8",
        color: "white",
      },
    },
    "&.checkout": {
      cursor: "default",
    },
  }));

  return (
    <>
      <Button className={`header-items ${classCheckout}`} onClick={showDrawer}>
        <AiOutlineShoppingCart className="icon-header" />
        &nbsp;&nbsp;
        <span>{countActualTrue}</span>
      </Button>
      <DrawerCartSummary
        openDrawer={openDrawer}
        hideDrawer={hideDrawer}
        onCloseDrawer={onCloseDrawer}
        backdropRef={backdropRef}
        countActual={countActualTrue}
      />
    </>
  );
}

export default CardButton;
